import AppErrorBoundary from '../AppErrorBoundary';
import Filter from '../Filter';
import MonthViewCharts from '../MonthViewCharts/MonthViewCharts';

export type MonthViewChartPanelProps = {
  isReturn: boolean;
};

const MonthViewChartPanel = ({ isReturn }: MonthViewChartPanelProps) => (
  <AppErrorBoundary location="tabbed-charts">
    <Filter className="month-view-filters" showCheckBox />
    <MonthViewCharts isReturn={isReturn} />
  </AppErrorBoundary>
);

export default MonthViewChartPanel;
